import * as t from "io-ts";
export const herokuOrchestratorEventT = t.strict({
    id: t.string,
    createdAt: t.string,
    actionType: t.string,
    service: t.string,
    data: t.UnknownRecord,
});
export const herokuOrchestratorEventsT = t.array(herokuOrchestratorEventT);
//# sourceMappingURL=heroku-orchestrator-events.js.map